import { t as trapFocus, r as removeTrapFocus } from "@theme/theme";
import DetailsModal from "@theme/details-modal";
class HeaderDrawer extends DetailsModal {
  constructor() {
    super();
    this.navToggles = [];
    setTimeout(() => {
      this.setupNavToggles();
    }, 0);
  }
  setupNavToggles() {
    this.navToggles = this.querySelectorAll("[data-nav-toggle]");
    this.navToggles.forEach((toggle) => {
      toggle.addEventListener("click", this.handleNavToggle.bind(this));
    });
    const closeButton = this.querySelector(".drawer-close");
    if (closeButton) {
      closeButton.addEventListener("click", () => {
        this.close();
      });
    }
    const backdrop = this.querySelector(".drawer-backdrop");
    if (backdrop) {
      backdrop.addEventListener("click", () => {
        this.close();
      });
    }
  }
  handleNavToggle(event) {
    event.preventDefault();
    event.stopPropagation();
    const toggle = event.currentTarget;
    const navItem = toggle.closest("[data-nav-item]");
    const submenu = navItem.querySelector("[data-nav-submenu]");
    const chevron = toggle.querySelector(".nav-chevron");
    if (!submenu) return;
    const isOpen = !submenu.classList.contains("hidden");
    if (isOpen) {
      submenu.classList.add("hidden");
      chevron.style.transform = "rotate(0deg)";
      toggle.setAttribute("aria-expanded", "false");
    } else {
      submenu.classList.remove("hidden");
      chevron.style.transform = "rotate(90deg)";
      toggle.setAttribute("aria-expanded", "true");
    }
  }
  open(event) {
    setTimeout(() => {
      this.detailsContainer.classList.add("menu-opening");
    });
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest("details").setAttribute("open", true);
    document.body.addEventListener("click", this.onBodyClickEvent);
    document.body.classList.add("overflow-hidden");
    trapFocus(this.detailsContainer.querySelector('[tabindex="-1"]'));
  }
  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    document.body.removeEventListener("click", this.onBodyClickEvent);
    this.detailsContainer.classList.remove("menu-opening");
    document.body.classList.remove("overflow-hidden");
    this.closeAllSubmenus();
    this.closeAnimation();
  }
  closeAllSubmenus() {
    const allSubmenus = this.querySelectorAll("[data-nav-submenu]");
    const allChevrons = this.querySelectorAll(".nav-chevron");
    allSubmenus.forEach((submenu) => {
      submenu.classList.add("hidden");
    });
    allChevrons.forEach((chevron) => {
      chevron.style.transform = "rotate(0deg)";
    });
    this.navToggles.forEach((toggle) => {
      toggle.setAttribute("aria-expanded", "false");
    });
  }
  closeAnimation() {
    let animationStart;
    const handleAnimation = (time) => {
      if (animationStart === void 0) {
        animationStart = time;
      }
      const elapsedTime = time - animationStart;
      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        this.detailsContainer.removeAttribute("open");
      }
    };
    window.requestAnimationFrame(handleAnimation);
  }
}
window.customElements.define("header-drawer", HeaderDrawer);
